const header = document.querySelector('.header');
const navMenu = document.querySelector('.header .nav__menu');
const navToggle = document.querySelector('.header .mobile-menu-container'); 
const navSubmenus = document.querySelectorAll('.header ul.nav__menu > .menu-item-has-children');
const navButtonsOpenSubmenu = document.querySelectorAll('.header .nav__btn_open');
const navButtonsCloseSubmenu = document.querySelectorAll('.header .nav__btn_close');
const navDropdownHoverBreakpoint = getComputedStyle(document.body).getPropertyValue('--header-breakpoint');
const navType = getComputedStyle(document.body).getPropertyValue('--header-type');
const navSearchOpen = document.querySelector('.header .nav__search_open');
const navSearchClose = document.querySelector('.header .nav__search_close');

/**
 * Open mobile navigation menu from toggle
 */
 if (navSearchOpen) {
    const navSearchInput = document.querySelector('.header .nav__search input[type="text"]');
    navSearchOpen.addEventListener('click', function () {
        nucleoResetMenuState();
        document.body.classList.add('search--is-open');
        header.classList.add('header--is-opaque');
        if(navSearchInput) {
            navSearchInput.focus();
        }
    });
}

if (navSearchClose) {
    navSearchClose.addEventListener('click', function () {
        document.body.classList.remove('search--is-open');
        header.classList.remove('header--is-opaque');
        navSearchOpen.focus();
    });
}


document.addEventListener('click', function (event) {
    if (document.body.classList.contains('nav--is-open')) {
        if (!document.querySelector('.nav__container').contains(event.target) && !(event.target.classList.contains('nav__toggle') || event.target.classList.contains('nav__toggle_icon')) ) {
            document.body.classList.remove("nav--is-open");
        }
    }
});

function nucleoResetMenuState() {
    navButtonsOpenSubmenu.forEach(function (el) {
        el.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('nav--is-open');
    navToggle.setAttribute('aria-expanded', 'false');
}

function getWidth() {
    return Math.max(
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
    );
}

function getHeight() {
    return Math.max(
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.documentElement.clientHeight
    );
}

/**
 * Open mobile navigation menu from toggle
 */
if (navToggle) {
    navToggle.addEventListener('click', function () {
        if ('true' !== navToggle.getAttribute('aria-expanded')) {
            navToggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('nav--is-open');
            navToggle.focus();
        } else {
            nucleoResetMenuState();
        }
    });
}

function nucleoToggleAriaExpanded(el) {
    if ('true' !== el.getAttribute('aria-expanded')) {
        el.setAttribute('aria-expanded', 'true');
    } else {
        el.setAttribute('aria-expanded', 'false');
    }
}

/**
 * Handle clicks on submenu toggles.
 */
if(navButtonsOpenSubmenu) {
    navButtonsOpenSubmenu.forEach(function (el) {

        el.addEventListener('click', function () {

            el.closest('ul').querySelectorAll('.nav__btn_open').forEach(function (button) {
                if (button !== el) {
                    //button.setAttribute('aria-expanded', 'false');
                } else {
                    // Toggle aria-expanded on the button.
                    nucleoToggleAriaExpanded(el);
                    document.body.classList.add('nav--is-open');
                }
            });


            el.parentNode.querySelectorAll('ul > li:last-child > a').forEach(function (linkEl) {
                linkEl.addEventListener('blur', function (event) {
                    if (!el.parentNode.contains(event.relatedTarget)) {
                        el.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        });
    });
}


/**
 * Handle clicks on submenu back toggles.

if(navButtonsCloseSubmenu) {
    navButtonsCloseSubmenu.forEach(function (el) {
        el.addEventListener('click', function () {
            nucleoToggleAriaExpanded(el.closest('.nav__submenu').previousElementSibling);
        });
    });
}
*/
/**
 * Trap keyboard navigation in the menu modal.
 */
document.addEventListener('keydown', function (event) {
    var elements, selectors, lastEl, firstEl, activeEl, shiftKey;

    if (!document.body.classList.contains('nav--is-open')) {
        return;
    }

    selectors = 'a, button';
    elements = navMenu.querySelectorAll(selectors);
    elements = Array.prototype.slice.call(elements);
    activeEl = document.activeElement;
    lastEl = elements[elements.length - 1];
    firstEl = elements[0];
    shiftKey = event.shiftKey;

    switch (event.key) {
        case "Escape":
            event.preventDefault();
            document.body.classList.remove('nav--is-open');
            nucleoResetMenuState();
            break;
        case "Tab":
            if (!shiftKey && lastEl === activeEl) {
                nucleoResetMenuState();
                document.body.classList.remove("nav--is-open");
            }
            if (shiftKey && firstEl === activeEl) {
                nucleoResetMenuState();
                document.body.classList.remove("nav--is-open");
            }
    }
});